import { EventEmitter, OnInit } from '@angular/core';
import { Modal } from "../../../core/ui/dialogs/modal.service";
import { ValueLists } from "../../../core/services/value-lists.service";
import { SelectPermissionsModalComponent } from "../select-permissions-modal/select-permissions-modal.component";
var PermissionsManagerPanelComponent = /** @class */ (function () {
    /**
     * PermissionsManagerPanelComponent Constructor.
     */
    function PermissionsManagerPanelComponent(modal, values) {
        this.modal = modal;
        this.values = values;
        /**
         * If start new permissions panel is currently active.
         */
        this.addNewPermissionsActive = false;
        /**
         * Internal permissions array.
         */
        this._permissions = [];
        /**
         * Errors from backend.
         */
        this.errors = {};
        /**
         * Fired when permissions array changes.
         */
        this.change = new EventEmitter();
    }
    Object.defineProperty(PermissionsManagerPanelComponent.prototype, "permissions", {
        /**
         * Permissions model.
         */
        set: function (permissions) {
            if (!permissions)
                return;
            this._permissions = Object.keys(permissions).map(function (permission) {
                return { name: permission, state: 1 };
            });
        },
        enumerable: true,
        configurable: true
    });
    PermissionsManagerPanelComponent.prototype.ngOnInit = function () {
        this.fetchAllPermissions();
    };
    /**
     * Show panel for attaching new permissions to plan.
     */
    PermissionsManagerPanelComponent.prototype.showAddPermissionsModal = function () {
        var _this = this;
        this.modal.open(SelectPermissionsModalComponent, { allPermissions: this.allPermissions }, { panelClass: 'select-permissions-modal-container' })
            .afterClosed()
            .subscribe(function (permissions) {
            if (!permissions)
                return;
            _this.addNewPermissions(permissions);
        });
    };
    /**
     * Remove given permission from model.
     */
    PermissionsManagerPanelComponent.prototype.removePermission = function (name) {
        var i = this._permissions.findIndex(function (permission) { return permission.name === name; });
        this._permissions.splice(i, 1);
        this.emitChangeEvent();
    };
    /**
     * Add given permissions to model.
     */
    PermissionsManagerPanelComponent.prototype.addNewPermissions = function (permissions) {
        var array = permissions.map(function (name) {
            return { name: name, state: 1 };
        });
        this._permissions = this._permissions.concat(array);
        this.emitChangeEvent();
    };
    PermissionsManagerPanelComponent.prototype.emitChangeEvent = function () {
        var permissions = {};
        this._permissions.forEach(function (permission) {
            permissions[permission.name] = permission.state;
        });
        this.change.emit(permissions);
    };
    /**
     * fetch permissions list from backend.
     */
    PermissionsManagerPanelComponent.prototype.fetchAllPermissions = function () {
        var _this = this;
        this.values.getPermissions().subscribe(function (response) {
            _this.allPermissions = response.permissions;
        });
    };
    return PermissionsManagerPanelComponent;
}());
export { PermissionsManagerPanelComponent };
